import monogramWebp128 from "@/assets/kakaiys-monogram-128.webp";
import monogramWebp256 from "@/assets/kakaiys-monogram-256.webp";
import monogramPng128 from "@/assets/kakaiys-monogram-128.png";
import monogramPng256 from "@/assets/kakaiys-monogram-256.png";

/**
 * KAKAIYS interlocking KK monogram — uses the official artwork as-is.
 * Optimized: WebP with PNG fallback, responsive srcset (128 / 256), lazy by default.
 * The `text-*` color classes no longer affect the artwork (full-color raster),
 * but the `strokeWidth` prop is preserved for API compatibility.
 */
export function Monogram({
  className = "",
  title = "KAKAIYS",
  eager = false,
}: {
  className?: string;
  /** Kept for API compatibility; ignored. */
  strokeWidth?: number;
  title?: string;
  /** Set true for above-the-fold instances (header, hero) to skip lazy-loading. */
  eager?: boolean;
}) {
  return (
    <picture>
      <source
        type="image/webp"
        srcSet={`${monogramWebp128} 128w, ${monogramWebp256} 256w`}
        sizes="(max-width: 768px) 64px, 128px"
      />
      <img
        src={monogramPng128}
        srcSet={`${monogramPng128} 128w, ${monogramPng256} 256w`}
        sizes="(max-width: 768px) 64px, 128px"
        alt={title}
        className={className}
        style={{ objectFit: "contain" }}
        draggable={false}
        loading={eager ? "eager" : "lazy"}
        decoding="async"
        fetchPriority={eager ? "high" : "auto"}
      />
    </picture>
  );
}
